import { AppConfiguration } from "../app-configuration";
export class SecuredConfiguration {
// GENERIC SECURED APIs
public static archiviaProfiloEProposta = AppConfiguration.SECURED + '/api/archiviaprofiloeproposta';
public static saveProfilo = AppConfiguration.SECURED + '/api/profilo/saveProfilo';
public static getProfilo = AppConfiguration.SECURED + '/api/profilo/getProfilo/';
public static getProfiloDettaglio = AppConfiguration.SECURED + '/api/profilo/getProfiloDettaglio/';
public static associaCompetenze = AppConfiguration.SECURED + '/api/profilo/associaCompetenze/';
public static validaProfilo = AppConfiguration.SECURED + '/api/profilo/validaProfilo';
public static rifiutaProfilo = AppConfiguration.SECURED + '/api/profilo/rifiutaProfilo';
public static associaConoscenza = AppConfiguration.SECURED + '/api/associaConoscenza/';
public static ricercaCodiceProfilo = AppConfiguration.SECURED + '/api/ricercacodiceprofilo/';
public static ricercaProfili = AppConfiguration.SECURED + '/api/profilo/ricercaProfili/';
public static ricercaProfiliProfessionali = AppConfiguration.COMMONS + '/ricercaProfiliProfessionali/';
public static ricercaProfiliRegione = AppConfiguration.SECURED + '/api/profilo/ricercaProfiliRegione/';
public static getTAreaProfiloAttivo = AppConfiguration.SECURED + '/api/getTAreaProfiloAttivo';
public static associaAbilita = AppConfiguration.SECURED + '/api/associaAbilita/';
public static getAbilitaByCompetenza = AppConfiguration.SECURED + '/api/getAbilitaByCompetenza/';
public static ricercaArchivioCompetenze = AppConfiguration.SECURED + '/api/ricercaArchivioCompetenze/';
public static getCompetenzeByIdProposta = AppConfiguration.SECURED + '/api/getCompetenzeByIdProposta/';
public static ricercaArchivioProposte = AppConfiguration.SECURED + '/api/ricercaArchivioProposte/';
public static assegnaCodiceProfilo = AppConfiguration.SECURED + '/api/assegnaCodiceProfilo';
public static downloadRestrictedManual = AppConfiguration.SECURED + '/api/manuals/download/filtered/user';

// ASSOCIAZIONI ASSEMBLEA
public static associaCompetenzeAssemblea = AppConfiguration.SECURED + '/api/associaCompetenzeAssemblea/';
public static associaProfiliAssemblea = AppConfiguration.SECURED + '/api/associaProfiliAssemblea/';


public static ricercaProfiliValidati = AppConfiguration.SECURED + '/api/profilo/ricercaProfiliValidati/';
public static ricercaCompetenzeValidate = AppConfiguration.SECURED + '/api/ricercaCompetenzeValidate/';

public static cancellaAssemblea = AppConfiguration.SECURED + '/api/cancellaAssemblea/';
public static chiudiAssemblea = AppConfiguration.SECURED + '/api/chiudiAssemblea';
public static confermaAssemblea = AppConfiguration.SECURED + '/api/confermaAssemblea';
public static getAssemblea = AppConfiguration.SECURED + '/api/getAssemblea/';

public static getCompetenzeAssegnateAssemblea = AppConfiguration.SECURED + '/api/getCompetenzeAssegnateAssemblea/';
public static getProfiliAssegnati = AppConfiguration.SECURED + '/api/getProfiliAssegnati/';

public static precaricaCodiceProfilo = AppConfiguration.SECURED + '/api/profilo/precaricaCodiceProfilo';

// FINE ASSOCIAZIONI ASSEMBLEA

public static ricercaAssemblea = AppConfiguration.SECURED + '/api/ricercaAssemblea/';
public static ricercaUtenti = AppConfiguration.SECURED + '/api/utenza/ricercaUtenti/';
public static caricaUtente = AppConfiguration.SECURED + '/api/utenza/caricaUtente/';
public static salvaUtenza = AppConfiguration.SECURED + '/api/utenza/saveUtenza';
public static duplicaProfilo = AppConfiguration.SECURED + '/api/profilo/duplicaProfilo/'
public static saveDuplicaProfilo = AppConfiguration.SECURED + '/api/profilo/saveDuplicaProfilo/'
public static saveModificaProfilo = AppConfiguration.SECURED + '/api/profilo/saveModificaProfilo'


public static archiviaProposta = AppConfiguration.SECURED + '/api/profilo/archiviaProposta'
// POST - valore = idProfilo



public static disableUtente = AppConfiguration.SECURED + '/api/utenza/disableutente/';
public static abilitaUtente = AppConfiguration.SECURED + '/api/utenza/abilitautente/';
public static caricaRuoliUtenti = AppConfiguration.SECURED + '/api/utenza/caricaRuoliUtenti';
public static getOperatoreByRuolo = AppConfiguration.SECURED + '/api/utenza/getOperatoreByRuolo/';
public static ricercaOperatori = AppConfiguration.SECURED + '/api/ricercaOperatori/';
public static caricaOperatore = AppConfiguration.SECURED + '/api/caricaOperatore/';
public static saveSede = AppConfiguration.SECURED + '/api/sede';
public static saveOperatore = AppConfiguration.SECURED + '/api/saveOperatore';
public static abilitaOperatore = AppConfiguration.SECURED + '/api/abilitaOperatore/';
public static disabilitaOperatore = AppConfiguration.SECURED + '/api/disabilitaOperatore/';


public static salvaAssemblea = AppConfiguration.SECURED + '/api/salvaAssemblea';
public static salvaAssembleaDecreto = AppConfiguration.SECURED + '/api/salvaAssembleaDecreto';
// public static uploadDocumentoDecreto = AppConfiguration.SECURED + '/api/uploadDocumentoDecreto';
//public static approvaCompetenza = AppConfiguration.SECURED + '/api/approvaCompetenza';
public static archiviaCompetenza = AppConfiguration.SECURED + '/api/archiviaCompetenza';
// POST - valore = id
//public static decretaCompetenza = AppConfiguration.SECURED + '/api/decretaCompetenza';
public static checkAbilitaConoscenze = AppConfiguration.SECURED + '/api/competenze/checkAbilitaConoscenze';
public static eliminaCompetenza = AppConfiguration.SECURED + '/api/eliminaCompetenza/';
public static eliminaCompetenzaCascade = AppConfiguration.SECURED + '/api/competenze/deleteCascade/';
public static eliminaProfiloProfessionale = AppConfiguration.SECURED + '/api/profilo/deleteProfilo/';
public static eliminaProfiloConCompetenze = AppConfiguration.SECURED + '/api/profilo/deleteCascade/';
public static checkCompetenzeProfilo = AppConfiguration.SECURED + '/api/profilo/checkCompetenze';
//public static getCodiciAdaByIdCompetenza = AppConfiguration.SECURED + '/api/getCodiciAdaByIdCompetenza';
//public static getCodiciAtecoByIdCompetenza = AppConfiguration.SECURED + '/api/getCodiciAtecoByIdCompetenza';
//public static getCodiciIscoByIdCompetenza = AppConfiguration.SECURED + '/api/getCodiciIscoByIdCompetenza';
//public static getCodiciIstatByIdCompetenza = AppConfiguration.SECURED + '/api/getCodiciIstatByIdCompetenza';
public static getCompetenza = AppConfiguration.SECURED + '/api/getCompetenza/';
public static getCompetenzaDettaglio = AppConfiguration.SECURED + '/api/getCompetenzaDettaglio/';
public static getAssociazioniArea = AppConfiguration.SECURED + '/api/aree/getNumeroAssociazioni/';
public static getRicercaCompetenzeDaAssociare = AppConfiguration.SECURED + '/api/getRicercaCompetenzeDaAssociare/';
public static getRicercaCompetenzeValidateDaAssociare = AppConfiguration.SECURED + '/api/ricercaCompetenzeValidate/';
//public static getRicercaCompetenzeDopoBozza = AppConfiguration.SECURED + '/api/getRicercaCompetenzeDopoBozza';
public static ricercaCompetenze = AppConfiguration.SECURED + '/api/ricercaCompetenze/';
public static profileHasDraftCompetences = AppConfiguration.SECURED + '/api/competenze/check/draft';
public static rifiutaCompetenzeByIdProfilo = AppConfiguration.SECURED + '/api/rifiuta/competenzeProfilo';
public static ricercaCompetenzeHP = AppConfiguration.COMMONS + '/ricercaCompetenze/';
//public static ricercaCompetenzeDecretate = AppConfiguration.SECURED + '/api/ricercaCompetenzeDecretate';
public static ricercaCompetenzeRegione = AppConfiguration.SECURED + '/api/ricercaCompetenzeRegione/';

public static rifiutaCompetenza = AppConfiguration.SECURED + '/api/rifiutaCompetenza';
public static rifiutaCompetenzaCascade = AppConfiguration.SECURED + '/api/competenze/rifiutaCascade/';
public static salvaCompetenza = AppConfiguration.SECURED + '/api/competenza/salva';
public static salvaModificaCompetenza = AppConfiguration.SECURED + '/api/modifica-competenza/salva';
public static sendCompetenza = AppConfiguration.SECURED + '/api/sendCompetenza/';
public static sendProfilo = AppConfiguration.SECURED + '/api/profilo/sendProfilo/';
public static validaCompetenza = AppConfiguration.SECURED + '/api/validaCompetenza';
public static getConoscenzeByCompetenza = AppConfiguration.SECURED + '/api/getConoscenzeByCompetenza/';
public static getAssociazioniConoscenze = AppConfiguration.SECURED + '/api/conoscenze';
public static ricercaConoscenze = AppConfiguration.SECURED + '/api/ricercaConoscenze/';
public static ricercaAbilita = AppConfiguration.SECURED + '/api/ricercaAbilita/';
public static saveConoscenza = AppConfiguration.SECURED + '/api/saveConoscenza';
public static saveAbilita = AppConfiguration.SECURED + '/api/saveAbilita';
public static getComuni = AppConfiguration.SECURED + '/api/getComuni/';
public static getProvince = AppConfiguration.SECURED + '/api/getProvince';
public static duplicaCompetenzaDecretata = `${AppConfiguration.SECURED}/api/competenza/duplica/`;
public static getStatiCompetenzaPerFunzioneElenco = AppConfiguration.SECURED + '/api/getStatiCompetenzaPerFunzioneElenco';
//public static getStatoCompetenza = AppConfiguration.SECURED + '/api/getStatoCompetenza';
//public static getStatoProposta = AppConfiguration.SECURED + '/api/getStatoProposta';
public static getStatoPropostaPerElenco = AppConfiguration.SECURED + '/api/getStatoPropostaPerElenco';
//public static getTAreaProfilo = AppConfiguration.SECURED + '/api/areaprofilo';
//public static getTipoAreaAteco = AppConfiguration.SECURED + '/api/getTipoAreaAteco';
//public static getTipologiaCompetenza = AppConfiguration.SECURED + '/api/getTipologiaCompetenza';
public static getTipoProcessi = AppConfiguration.SECURED + '/api/getTipoProcessi/';
public static getTipoSequenze = AppConfiguration.SECURED + '/api/getTipoSequenze/';
public static getTipoSottoarea = AppConfiguration.SECURED + '/api/getTipoSottoarea/';
public static getStatoPropostaPerArchivio = AppConfiguration.SECURED + '/api/getStatoPropostaPerArchivio';
public static getStatoCompetenzaPerArchivio = AppConfiguration.SECURED + '/api/getStatoCompetenzaPerArchivio';
public static etlOperatori = AppConfiguration.SECURED + '/api/etlOperatori';
public static etlSedi = AppConfiguration.SECURED + '/api/etlSedi';
public static reportProfiloProfessionalePdf = AppConfiguration.SECURED + '/api/reportProfiloProfessionale/';
//public static reportProfiloProfessionalePdfHP = AppConfiguration.SECURED + '/commons/reportProfiloProfessionale/';
public static reportProfiloProfessionaleXls = AppConfiguration.SECURED + '/api/reportProfiloProfessionaleXls/';
public static reportPropostaCompetenzaPdf = AppConfiguration.SECURED + '/api/reportPropostaCompetenzaPdf/';
//public static reportPropostaCompetenzaPdfHP = AppConfiguration.SECURED + '/commons/reportPropostaCompetenzaPdf/';
public static reportPropostaCompetenzaXls = AppConfiguration.SECURED + '/api/reportPropostaCompetenzaXls/';
public static getTipoAreaCaricamento = AppConfiguration.SECURED + '/api/getTipoAreaCaricamento';
public static getTipologieAllegato = AppConfiguration.SECURED + '/api/tipologieallegato';
public static downloadAllegato = AppConfiguration.SECURED + '/api/allegato';
public static getDocumenti = AppConfiguration.SECURED + '/api/getListaDocumenti/';
public static getTipologie = AppConfiguration.SECURED + '/api/getTipologie';
public static getTipoStati = AppConfiguration.SECURED + '/api/getTipoStati';
public static ricercaAbilitaConoscenze = AppConfiguration.SECURED + '/api/ricercaAbilitaConoscenze';
public static ricercaCompetenzeArchivio = AppConfiguration.SECURED + '/api/ricercaCompetenze';
public static getDocumento = AppConfiguration.SECURED + '/api/getDocumento/';
public static salvaAreaCaricamento = AppConfiguration.SECURED + '/api/salvaAreaCaricamento';
public static eliminaDocumento = AppConfiguration.SECURED + '/api/eliminaDocumento/';
public static getStatiAssemblea = AppConfiguration.SECURED + '/api/getStatiAssemblea';
public static uploadFile = AppConfiguration.SECURED + '/api/uploadFile';
public static downloadDocumentoPdf = AppConfiguration.SECURED + '/api/downloadDocumento'

public static ricercaListaTipoOperatori = AppConfiguration.SECURED + '/api/ricercaListaTipoOperatori';
//public static logout = AppConfiguration.SECURED + '/api/callLogout';
public static logout = '/logout';
public static getUrlRedirect = AppConfiguration.SECURED + '/api/getUrlRedirect';

// GESTIONE AREE
public static getAreeSep = AppConfiguration.SECURED + '/api/aree/getAreeSep';
public static getStatiAree = AppConfiguration.SECURED + '/api/aree/getStatiAree';
public static ricercaAree = AppConfiguration.SECURED + '/api/aree/ricerca/';
public static salvaArea = AppConfiguration.SECURED + '/api/aree/salva';
}
